import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import Card from '@mui/material/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import CircularProgress from '@mui/material/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-react/views/extendedFormsStyle.jsx';

const CustomIntgComp = (props) => {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');

  const { getCustomIntgs } = props;
  useEffect(() => {
    getCustomIntgs();
  }, [getCustomIntgs]);

  useEffect(() => {
    setMessage(props.message);
    var rowItems = [];
    if (props.custom_intg_list.length > 0) {
      for (let i = 0; i < props.custom_intg_list.length; i++) {
        var colItems = [];
        colItems.push(i + 1);
        colItems.push(props.custom_intg_list[i].id);
        colItems.push(props.custom_intg_list[i].intg_field_name);
        colItems.push(props.custom_intg_list[i].key);
        colItems.push(props.custom_intg_list[i].value);
        colItems.push(props.custom_intg_list[i].value_display);
        rowItems.push(colItems);
      }
    }
    setData(rowItems);
  }, [props]);

  const columns = [
    'Serial',
    'ID',
    'Field Name',
    'Key',
    'Value',
    'Display Value',
  ];
  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    filter: true,
    selectableRows: 'none',
    rowsPerPage: 100,
    selectToolbarPlacement: 'none',
  };
  return (
    <div>
      {props.requesting && <CircularProgress size={44} style={{ position: 'absolute', top: '50%', left: '50%' }} />}
      <Card>
        <CardHeader color="primary" style={{ textAlign: 'left', paddingTop: '30px' }}>
          <b>Custom Integration Fields</b>
        </CardHeader>
        <CardBody>
          <div style={{ color: 'red', textAlign: 'center' }}>{message}</div>
          <MUIDataTable
            data={data}
            columns={columns}
            options={options}
          />
        </CardBody>
      </Card>
    </div>
  );
};
export default withStyles(extendedFormsStyle)(CustomIntgComp);
